window.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('letterFilter')) {
    import('./_letter-filter.js').then((module) => {
      module.Init();
    });
  }
});
  
export default {}